<template>
  <!-- 下载区域 -->
  <section id="hero" class="d-flex align-items-center hero-section">
    <!-- PC端hero内容 -->
    <div class="hero-pc d-none d-lg-block">
      <div class="hero-bg"></div>
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="text-center text-lg-start">
            <div class="hero-text fade-in-up">
              <h1>39游戏盒子，您的游戏库和随身礼包助手！</h1>
            </div>
            <div class="d-flex flex-column flex-sm-row mt-4 download-buttons justify-content-center fade-in-up delay-1">
              <a href="https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=348" class="btn-primary btn-lg download-btn-bg hero-download-btn" target="_blank">游戏盒子下载</a>
            </div>
          </div>
        </div>
      </div>
      
      <!-- PC端鼠标滚动提示 -->
      <div class="scroll-indicator fade-in-up delay-2">
        <div class="mouse">
          <div class="mouse-wheel"></div>
        </div>
        <div class="scroll-arrows">
          <div class="arrow-down"></div>
          <div class="arrow-down"></div>
        </div>
      </div>
    </div>

    <!-- 移动端hero内容 -->
    <div class="hero-mobile d-lg-none">
      <div class="hero-mobile-bg">
        <img src="@/assets/images/mbg.png" style="width: 100%; height: 100%;" alt="">
      </div>
      <div class="container">
        <div class="hero-mobile-content">
          <div class="hero-mobile-text fade-in-up">
            <h1>39游戏盒子</h1>
            <p>您的游戏库和随身礼包助手！</p>
          </div>
          <div class="hero-mobile-download fade-in-up delay-1">
            <a href="https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=352" class="mobile-download-btn hero-download-btn" target="_blank">游戏盒子下载</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  methods: {
    handleDownload() {
      this.$emit('download');
    }
  }
}
</script>

<style scoped>
/* Hero区域整体动画 */
.hero-section {
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

/* 渐入向上动画 */
.fade-in-up {
  /* opacity: 0; */
  transform: translateY(30px);
  animation: fadeInUp 0.8s ease-out forwards;
}

.fade-in-up.delay-1 {
  animation-delay: 0.3s;
}

.fade-in-up.delay-2 {
  animation-delay: 0.6s;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-download-btn:active {
  transform: translateY(-1px) scale(1.01);
}

/* 鼠标滚动指示器动画 */
.scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  animation: bounce 2s infinite;
}

.mouse {
  width: 24px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  position: relative;
  margin: 0 auto 10px;
}

.mouse-wheel {
  width: 4px;
  height: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
}

.scroll-arrows {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.arrow-down {
  width: 8px;
  height: 8px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.8);
  border-right: 2px solid rgba(255, 255, 255, 0.8);
  transform: rotate(45deg);
  animation: arrowBounce 2s infinite, arrowPulse 1.5s infinite;
}

@keyframes arrowPulse {
  0% {
    border-color: rgba(255, 255, 255, 0.4);
  }
  50% {
    border-color: rgba(255, 255, 255, 1);
  }
  100% {
    border-color: rgba(255, 255, 255, 0.4);
  }
}

.arrow-down:nth-child(2) {
  animation-delay: 0.2s;
}

</style>